// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__30Ccr","AuthBoxContainer":"Auth_AuthBoxContainer__3XSmQ","SwapSignUp":"Auth_SwapSignUp__HP38G","SwapText":"Auth_SwapText__1W8-w"};